import * as z from "zod";

const refulfillmentDashboardDaySchema = z.object({
  date: z.string(),
  orders: z.number(),
});

export const refulfillmentDashboardDaySeriesSchema = z.object({
  days: z.array(refulfillmentDashboardDaySchema),
  /** The window of the same length immediately before `days`, aligned by index. */
  previousDays: z.array(refulfillmentDashboardDaySchema),
  previousPeriodTotal: z.number(),
});

const seriesDaysSchema = z.number().int().min(1).max(365).default(7);

/**
 * The two history charts, apart from `getRefulfillmentDashboard` so a range
 * change or a refresh of the live board does not recompute the other.
 */
export const getRefulfillmentDashboardHistory = {
  name: "getRefulfillmentDashboardHistory" as const,
  input: z.object({
    teamIds: z.array(z.string()).optional(),
    /** The viewer's IANA timezone; an invalid one falls back to UTC, echoed as `timezone`. */
    timezone: z.string(),
    volumeDays: seriesDaysSchema,
    openOver24hDays: seriesDaysSchema,
  }),
  output: z.object({
    generatedAt: z.string(),
    timezone: z.string(),
    volumeByDay: refulfillmentDashboardDaySeriesSchema,
    openOver24hByDay: refulfillmentDashboardDaySeriesSchema,
  }),
};

export type RefulfillmentDashboardHistoryInput = z.infer<
  (typeof getRefulfillmentDashboardHistory)["input"]
>;
export type RefulfillmentDashboardHistory = z.infer<
  (typeof getRefulfillmentDashboardHistory)["output"]
>;
export type RefulfillmentDashboardDaySeries = z.infer<
  typeof refulfillmentDashboardDaySeriesSchema
>;
